module.exports = __webpack_public_path__ + "lifestyle.png?6cd07f2a2ced95db6416071f7f15a078";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lifestyle.png
// module id = 173
// module chunks = 0